import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useParams, useLocation } from 'react-router-dom';
import { authActions, authSelectors } from '../modules/auth';
import { LocalAlert, LoadingSpinner } from 'fni-components-next';
import { coreActions } from '../../redux/CoreSlice/core';
import { useEffect } from 'react';

// Routes that handle their own loading states - don't show global spinner
const routesWithOwnSpinner = [
    '/auth/login/',
    '/auth/saml/callback',
];

export default function Authentication() {

    const dispatch = useDispatch();
    const { code } = useParams();
    const { pathname } = useLocation();
    const isLoading =  useSelector(authSelectors.authLoading);
    const authAlert = useSelector(authSelectors.authAlert);
    const promptPasskeySetup = useSelector(authSelectors.promptPasskeySetup);

    useEffect(() => {
        if(code) dispatch(coreActions.setCode(code));
    }, []);

    // Don't show global spinner on routes that have their own loading indicators
    const hasOwnSpinner = routesWithOwnSpinner.some(route => pathname.startsWith(route));
    const showGlobalSpinner = isLoading && !hasOwnSpinner;

    return (
        <>
            <LocalAlert alert={authAlert} onHideAlert={() => dispatch(authActions.hideAlert())} />
            <Outlet />
            {/* Hide loading spinner when passkey setup prompt is shown to prevent double backdrop */}
            <LoadingSpinner open={isLoading && !promptPasskeySetup} />
        </>
    );
}
